import React, { useState } from 'react'
import {Link, Route, Routes, BrowserRouter, Navigate} from "react-router-dom";
import Footer from './components/container/footer';
import About from './components/pages/about';
import Bosque from './components/pages/bosque';
import Contacto from './components/pages/contacto';
import FAQ from './components/pages/FAQ';
import HomeCalculator from './components/pages/homeCalculator';
import Home from './components/pages/home';
import menuIcon from "./icons/menu.png"
import menuOpenIcon from "./icons/menuOpen.png"
import logo from "./icons/logo.png"


import "./style/style.scss";


function App() {

  const [menu, setMenu] = useState(false)

  return (

    <BrowserRouter>
        <aside className=" d-md-flex d-none bg-success py-3 flex-row justify-content-between px-5 ">
            <img width="200px" src={logo} alt="logo"></img>

            <div className="d-flex flex-row gap-3 align-items-center justify-content-center">
              <Link to="/" className='text-decoration-none text-light regularText'>INICIO</Link> 
              <Link to="/bosque-comunitario" className='text-decoration-none text-light regularText'>Bosque Comunitario</Link> 
              <Link to="/calculadora" className='text-decoration-none text-light regularText'>Calculdora</Link> 
              <Link to="/quienes-somos" className='text-decoration-none text-light regularText'>Quienes Somos</Link> 
              <Link to="/contacto" className='text-decoration-none text-light regularText'>Contacto</Link> 
            </div>
        </aside>

        <aside className=" d-md-none d-flex flex-column">
            <div className="col-12 bg-success d-flex flex-row justify-content-between align-items-center px-3">
              <img className="col-5" src={logo} alt="logo" ></img>
              <span>
                  {menu===false&&<img className="white" onClick={()=> setMenu(!menu)} alt="menuIcon" src={menuIcon}></img>}
                  {menu===true&&<img className="white" onClick={()=> setMenu(!menu)} alt="menuOpenIcon" src={menuOpenIcon}></img>}
              </span>
            </div>
            {menu===true?
            <div className="col-12 d-flex flex-column gap-2 text-center military3Bg py-5">
              <Link to="/" className='fs-4 col-12 text-decoration-none text-light regularText'>Inicio</Link> 
              <Link to="/bosque-comunitario" className='fs-4 col-12 text-decoration-none text-light regularText'>Bosque Comunitario</Link> 
              <Link to="/calculadora" className='text-decoration-none text-light regularText'>Calculdora</Link> 
              <Link to="/quienes-somos" className='fs-4 col-12 text-decoration-none text-light regularText'>Quienes Somos</Link> 
              <Link to="/contacto" className='fs-4 col-12 text-decoration-none text-light regularText'>Contacto</Link> 
            </div>
            :  
            <span></span>
           }
        </aside>
 
        <main regularText>
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='bosque-comunitario' element={<Bosque/>}/>
                <Route path='contacto' element={<Contacto/>}/>
                <Route path='faq' element={<FAQ/>}/>
                <Route path='quienes-somos' element={<About/>}/>
                <Route path='calculadora' element={<HomeCalculator/>}/>
            </Routes>
        </main>
        <Footer/>
    </BrowserRouter>
  )
}

export default App